// extracted by mini-css-extract-plugin
export var avatarContainer = "_ar-0";
export var avatarTypingWave = "_ar-i";
export var gray = "_ar-f";
export var green = "_ar-c";
export var icon = "_ar-9";
export var image = "_ar-1";
export var lg = "_ar-6";
export var md = "_ar-5";
export var presenceDot = "_ar-b";
export var red = "_ar-d";
export var sm = "_ar-4";
export var status = "_ar-a";
export var typingDot = "_ar-h";
export var typingPill = "_ar-g";
export var xl = "_ar-7";
export var xs = "_ar-3";
export var xxl = "_ar-8";
export var xxs = "_ar-2";
export var yellow = "_ar-e";